<!--
 * @Author: cryi.liu
 * @Date: 2020-05-08 09:56:23
 * @LastEditTime: 2020-06-20 14:37:41
 * @Description: 题干
 -->
<template>
  <div>
    <div class="question-stem">
      <p class="title">所属题库</p>
      <div class="item">
        <i-select
          v-model="stem.libraryType"
          filterable
          size="small"
          :disabled="readonly"
        >
          <i-option
            v-for="item in menu.libraryTypes"
            :value="item"
            :key="item"
            >{{ item }}</i-option
          >
        </i-select>
      </div>
    </div>
    <div class="question-stem">
      <p class="title">难易度</p>
      <div class="item">
       <i-select
          v-model="stem.level"
          filterable
          size="small"
          :disabled="readonly"
        >
           <i-option
            v-for="item in menu.levels"
            :value="item"
            :key="item"
            >{{ item }}</i-option
          >
        </i-select>
      </div>
    </div>
    <div class="question-stem">
      <p class="title">年份</p>
      <div class="item">
       <i-select
          v-model="stem.year"
          filterable
          size="small"
          :disabled="readonly"
        >
          <i-option
            v-for="item in menu.years"
            :value="item"
            :key="item"
            >{{ item }}</i-option
          >
        </i-select>
      </div>
    </div>
    <div class="question-stem">
      <p class="title">产品组</p>
      <div class="item">
       <i-select
          v-model="stem.groupCode"
          filterable
          size="small"
          :disabled="readonly"
        >
          <i-option
            v-for="item in menu.groupCodes"
            :value="item"
            :key="item"
            >{{ item }}</i-option
          >
        </i-select>
      </div>
    </div>
    <div class="question-stem">
      <p class="title">型号简称</p>
      <div class="item">
        <i-input
          ref="stem-input"
          :value="stem.shortName"
          :readonly="readonly"
          @on-change="stemInputChangedHandler2"
        >
        </i-input>
      </div>
    </div>
    <div class="question-stem">
      <p class="title">题干</p>
      <div class="item">
        <i-input
          ref="stem-input"
          :value="stem.content"
          :readonly="readonly"
          @on-change="stemInputChangedHandler"
        >
        </i-input>
        <upload-media-file
          v-if="mediaType"
          control="stem"
          :library-id="libraryId"
          @repull-question-info="repullQuestionInfo"
        />
      </div>
      <p v-if="stem.mediaPath" class="media-path">
        <span>媒体预览：</span>
        <a href="javascript:void(0)" @click="previewMedia(stem)">{{
          stem.mediaPath
        }}</a>
        <i-icon class="icon-delete" type="md-trash" @click="deleteMediaFile" />
      </p>
    </div>
    <i-button
      slot="suffix"
      style="margin-bottom: 10px"
      :type="btnType"
      @click="canEditOrSaveQuestionStemHandler"
      >{{ btnText }}</i-button
    >
  </div>
</template>

<script>
import UploadMediaFile from "./UploadMediaFile.vue";

export default {
  name: "QuestionStem",
  components: {
    UploadMediaFile,
  },
  props: {
    libraryId: { type: String, required: true },
    stem: { type: Object, reuqired: true },
    menu: { type: Object, reuqired: true },
    mediaType: { type: Boolean, required: true },
  },
  data() {
    return {
      tempStem: "",
      tempLibraryType: "",
      tempLevel: "",
      tempYear: "",
      tempShortName: "",
      tempGroupCode: "",
      readonly: true,
      btnText: "修改以上内容",
      btnType: "primary",
    };
  },
  watch: {
    stem: {
      immediate: true,
      deep: true,
      handler(stem) {
        if (!stem.content) stem.content = "";
        const content = stem.content.replace(/\[\]/g, "__");

        stem.content = content;
        this.tempStem = stem.content;
      },
    },
  },
  methods: {
    /**
     * 媒体文件预览
     */
    previewMedia({ mediaPath, realMediaPath, videoCover }) {
      this.$emit("preview-media", { mediaPath, realMediaPath, videoCover });
    },
    /**
     * 启用修改或者保存题目题干内容信息
     */
    canEditOrSaveQuestionStemHandler() {
      if (this.readonly) {
        this.readonly = false;
        this.btnText = "保存以上内容";
        this.btnType = "success";

        this.$refs["stem-input"].focus();
      } else {
        this.saveQuestionStemHandler();
      }

      this.$emit("set-stem-edit-flag", !this.readonly);
    },
    /**
     * 保存题目题干内容处理函数
     */
    saveQuestionStemHandler() {
      // if (this.tempStem === this.stem.content) {
      //   this.readonly = true;
      //   this.btnText = "修改";
      //   this.btnType = "primary";
      //   return;
      // }

      if (!this.mediaType) {
        if (this.tempStem === "") {
          alert("题干内容不能为空");
          return;
        }
      }
       if (this.stem.libraryType === "") {
          alert("所属题库不能为空");
          return;
        }
        if (this.stem.level === "") {
          alert("难易度不能为空");
          return;
        }
        if (this.stem.year === "") {
          alert("年份不能为空");
          return;
        }
        if (this.stem.groupCode === "") {
          alert("产品组不能为空");
          return;
        }

      this.requestSaveQuestionInfoAndSetting();
    },
    /**
     * 题干输入框内容修改
     */
    stemInputChangedHandler(e) {
      this.tempStem = e.target.value;
    },
    stemInputChangedHandler2(e) {
      this.stem.shortName = e.target.value;

    },
    /**
     * 重新请求题目信息
     */
    repullQuestionInfo() {
      this.$emit("repull-question-info");
    },
    /**
     * 删除多媒体文件
     */
    deleteMediaFile() {
      if (window.confirm("确认删除多媒体文件？")) {
        this.requestDeleteStemMediaFile()
          .then(() => {
            alert("删除多媒体文件成功");

            this.repullQuestionInfo();
          })
          .catch((result) => {
            alert(result.msg);
          });
      }
    },
    /**
     * 请求删除题干多媒体文件
     */
    requestDeleteStemMediaFile() {
      const params = {
        id: this.libraryId,
        mediaPath: "",
      };

      return new Promise(async (resolve, reject) => {
        const result = await this.$http.examcenter.librarySaveQuestion(params);

        if (result.code === "200") {
          resolve(result);
        } else {
          reject(result);
        }
      });
    },
    /**
     * 请求保存题库题目题干信息并设置
     */
    requestSaveQuestionInfoAndSetting() {
      this.requestSaveQuestionInfo()
        .then(() => {
          alert("以上内容保存成功");
          const stem = JSON.parse(JSON.stringify(this.stem));
          stem.content = this.tempStem;

          this.readonly = true;
          this.btnText = "修改以上内容";
          this.btnType = "primary";

          this.$emit("set-stem", stem);
        })
        .catch((result) => {
          alert(result.msg);
        });
    },
    /**
     * 请求保存题库题目题干信息
     */
    requestSaveQuestionInfo() {
      // const content = this.tempStem.replace(/__/g, '[]');
      const params = {
        id: this.libraryId,
        content: this.tempStem,
        libraryType: this.stem.libraryType,
        level: this.stem.level,
        year: this.stem.year,
        groupCode: this.stem.groupCode,
        shortName: this.stem.shortName
      };

      return new Promise(async (resolve, reject) => {
        const result = await this.$http.examcenter.librarySaveQuestion(params);

        if (result.code === "200") {
          resolve(result.data);
        } else {
          reject(result);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.question-stem {
  margin-bottom: 16px;
  width: 100%;

  > .title {
    margin-bottom: 18px;
    font-size: 16px;
    font-weight: bold;
  }

  > .item {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    height: 36px;

    /deep/ .ivu-input-wrapper {
      .ivu-input-suffix {
        width: 58px;
      }
    }
  }

  > .media-path {
    padding: 6px 0;
    font-size: 12px;

    > span {
      font-weight: bold;
    }

    > a {
      text-decoration: underline;
    }

    > .icon-delete {
      margin-left: 12px;
      font-size: 16px;
      cursor: pointer;
    }
  }
}
</style>
